const crop_list = {
	apricot_tree: String("ALBERCOQUERS"),
	aubergine: String("ALBERGÍNIA"),
	basil: String("ALFÀBREGA"),
	alfalfa: String("ALFALS"),
	other_fruit_trees: String("ALTRES FRUITERS"),
	almond_trees: String("AMETLLERS"),
	anethum_graveolens: String("ANET"),
	celery: String("API"),
	rice: String("ARRÒS"),
	hazelnut_tree: String("AVELLANER"),
	corn: String("BLAT DE MORO"),
	durum_wheat: String("BLAT DUR"),
	khorasan_wheat: String("BLAT KHORASAN"),
	soft_wheat: String("BLAT TOU"),
	swiss_chard: String("BLEDA"),
	common_marigold: String("CALÈNDULA"),
	mushrooms: String("BOLETS"),
	borage: String("BORRATJA"),
	hemp: String("CÀNEM"),
	peanut: String("CACAUET"),
	camomile: String("CAMAMILLA"),
	camelina: String("CAMELINA"),
	common_cane: String("CANYA COMUNA"),
	khaki: String("CAQUI"),
	pumkpin: String("CARABASSA"),
	zucchini: String("CARBASSÓ"),
	artichoke: String("CARXOFA"),
	chestnut_tree: String("CASTANYERS"),
	onions_garlick: String("CEBES, CALÇOTS, PORROS I ALLS"),
	chickpea: String("CIGRONS"),
	cherry_tree: String("CIRERERS"),
	oat: String("CIVADA"),
	clementine: String("CLEMENTINA"),
	quince_tree: String("CODONY"),
	cucumber: String("COGOMBRE"),
	cabbage_and_coliflower: String("COL I COLIFLOR"),
	colza: String("COLZA"),
	coriander: String("CORIANDRE"),
	watercress: String("CRÈIXENS"),
	tail_of_rat: String("CUA DE RATA"),
	date: String("DÀCTIL"),
	lettuce: String("ENCIAM"),
	endive_chicory: String("ENDÍVIA, ESCAROLA I XICOIRA"),
	erbs: String("ERBS"),
	canary_grass: String("ESCAIOLA"),
	asparagus: String("ESPARRECS"),
	aromatic_herbs: String("ESPECIES AROMÀTIQUES HERBÀCIES"),
	woody_aromatiques: String("ESPECIES AROMATIQUES LLENYOSES"),
	spelt: String("ESPELTA"),
	spinach: String("ESPINAC"),
	buckwheat: String("FAJOL"),
	thyme: String("FARIGOLA O TIMÓ"),
	moreu: String("FAVERA BORDA O MOREU"),
	beans: String("FAVES I FAVONS"),
	fenugreek: String("FENIGREC"),
	festuca: String("FESTUCA"),
	fig_tree: String("FIGUERA"),
	flowers_and_ornamental: String("FLORS I ORNAMENTALS"),
	fennel: String("FONOLL"),
	fruit_trees: String("FRUITERS VARIS"),
	green_pea: String("GARLANDA"),
	carob_tree: String("GARROFER"),
	blueberry: String("GERDS"),
	sunflower: String("GIRA-SOL"),
	redcurrant: String("GROSELLA"),
	lying_fallow: String("GUARET"),
	lathyrus_sativus: String("GUIXES"),
	hyssop: String("HISOP"),
	orchard: String("HORTA"),
	parsley: String("JULIVERT"),
	kiwi: String("KIWI"),
	lavender: String("ESPÍGOL"),
	hop: String("LLÚPOL"),
	lentils: String("LLENTIES"),
	linen: String("LLI"),
	lemons: String("LLIMONER"),
	strawberry: String("MADUIXA"),
	pomegranate_tree: String("MAGRANER"),
	mandarin_tree: String("MANDARINER"),
	marjoram: String("MARDUIX"),
	melon: String("MELÓ"),
	orange_blossom: String("MELISSA O TARONGINA"),
	mint: String("MENTA"),
	mestall: String("MESTALL"),
	mill: String("MILL"),
	alt_beans_1: String("MONGETA"),
	blueberrys: String("NABIUS"),
	chinese_turnip_and_cabbage: String("NAP I COL XINESA"),
	nashi: String("NASHI"),
	nectarine_tree: String("NECTARINS"),
	medlar: String("NESPRER"),
	walnut_trees: String("NOGUERES"),
	olive_trees: String("OLIVERES"),
	barley: String("ORDI"),
	oregano: String("ORENGA"),
	pea_and_oat: String("PÈSOL I CIVADA"),
	peas_and_barley: String("PÈSOL I ORDI"),
	peas: String("PÈSOLS"),
	carrot: String("PASTANAGA"),
	potato: String("PATATA"),
	pepper: String("PEBROT"),
	pear_trees: String("PERERES"),
	pear_apple_tree: String("PERERES/POMERES"),
	hypericum_or_saint_johns_wort: String("PERICÓ O HERBA DE SANT JOAN"),
	pistachio: String("PISTATXER O FESTUC"),
	bread_poa: String("POA"),
	grapefruit: String("POMELO O ARANJA"),
	apple_trees: String("POMERES"),
	peach_trees: String("PRESSEGUERS"),
	peach_nectarine_tree: String("PRESSEGUERS/NECTARINS"),
	plum_tree: String("PRUNERES"),
	quinoa: String("QUINOA"),
	grape: String("RAÏM DE TAULA"),
	radish: String("RAVE"),
	ray_grass: String("RAY-GRASS"),
	beetroot: String("REMOLATXA"),
	rosemary: String("ROMANÍ"),
	rye: String("SÈGOL"),
	watermelon: String("SÍNDRIA"),
	saffron: String("SAFRÀ"),
	sajolida: String("SAJOLIDA"),
	satsuma_tangerine: String("SATSUMA"),
	soy: String("SOIA"),
	sorghum: String("SORGO"),
	sulla: String("SULLA  O ENCLOVA"),
	truffle: String("TÒFONA"),
	tobacco: String("TABAC"),
	orange_tree: String("TARONGER"),
	tomato: String("TOMÀQUET"),
	clover: String("TRÈVOL"),
	sweet_lupine: String("TRAMUSSOS DOLÇOS"),
	sainfoin: String("TREPADELLA"),
	triticale: String("TRITICALE"),
	tritordeum: String("TRITORDEUM"),
	vetch_and_wheat: String("VEÇA I BLAT"),
	vetch_and_oat: String("VEÇA I CIVADA"),
	efa_vetch_and_barley: String("VEÇA I ORDI"),
	efa_vetch_and_triticale: String("VEÇA I TRITICALE"),
	vetch: String("VECES"),
	vineyards: String("VINYES"),
	nursery_tree_and_shrub: String("VIVER ARBRE I ARBUST"),
};

export default crop_list;